import {
  GET_OPTIONS_REQUEST,
  GET_OPTIONS_SUCCESS,
  GET_OPTIONS_FAILURE,
} from "actions/option";

const initialState = {
  loading: false,
  dnsp: [],
  region: [],
  meter_model: [],
  error: {},
};

export default function option(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_OPTIONS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_OPTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        ...payload,
        meter_model: payload.meter_model.reverse()
          .sort((a, b) => a.model === "ADL200M" ? -1 : b.model === "ADL200M" ? 1 : 0)
          .map((it) => {
            const suffix = ["ADL400"].includes(it.model)
            ? " RETIRED - NOT FOR NEW INSTALLS"
            : "";
          return {
            ...it,
            value: it.model,
            label: `${it.manufacturer} ${it.model}${suffix}`,
          };
        }),
      };
    }

    case GET_OPTIONS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
}
